<template>
  <b-modal
    id="modal-cadastro-legislacao"
    size="xl"
    button-size="sm"
    header-bg-variant="secondary"
    header-text-variant="light"
    header-class=""
    footer-class=""
    modal-class="p-2"
    no-close-on-backdrop
    no-close-on-esc
  >
    <template v-slot:modal-header="">
      <h5>Cadastro de Legislações</h5>
    </template>

    <entrega-legislacao
      :openInModal="true"
      @fecharModalLegislacao="$emit('fechar', $event)"
    />

    <template v-slot:modal-footer="">
      <b-button
        size="sm"
        variant="outline-secondary"
        @click="$emit('fechar')"
      >
        Fechar
      </b-button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import EntregaLegislacao from "@/views/entregas/legislacao/EntregaLegislacao.vue";

@Component({
  components: { EntregaLegislacao },
})
export default class ModalCadastroLegislacao extends mixins(UtilsTS, Vue) {}
</script>
